import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/welcome.png'


const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "card bg-hero-primary border-0 rounded-3 welcome-box mb-4" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "row align-items-center" }
const _hoisted_6 = { class: "col-lg-8 col-md-8 col-sm-8" }
const _hoisted_7 = { class: "border-bottom mb-3" }
const _hoisted_8 = { class: "text-white fw-semibold mb-1" }
const _hoisted_9 = { class: "text-danger-div" }
const _hoisted_10 = { class: "text-light" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-lg-6 col-md-6 col-12" }
const _hoisted_13 = { class: "d-flex align-items-center welcome-status-item" }
const _hoisted_14 = { class: "flex-grow-1 ms-3" }
const _hoisted_15 = { class: "text-light mb-0" }
const _hoisted_16 = { class: "text-white fw-bold mb-0" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-lg-6" }
const _hoisted_19 = { class: "col-lg-6" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-12" }
const _hoisted_22 = {
  key: 0,
  class: "row mt-0"
}
const _hoisted_23 = { class: "col-12" }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = {
  key: 2,
  class: "row mt-0"
}
const _hoisted_26 = { class: "col-12" }

import { computed } from 'vue';
import { t } from '@/utils/i18nHelper';
import { authStore } from '@/stores/auth';
import TaxBreakdownChart from './TaxBreakdownChart.vue';
import DeadlinesWidget from './DeadlinesWidget.vue';
import LiquidityStatsBoxes from './LiquidityStatsBoxes.vue';
import LiquidityScheduleTable from './LiquidityScheduleTable.vue';
import MonthlyFlowChart from './MonthlyFlowChart.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TaxResults',
  props: {
  results: {
    type: Object,
    required: true,
  },
  liquidityResults: { // New prop
    type: Object,
    required: false,
  },
  contributionRegime: {
    type: String,
    required: true,
  },
  formData: { // New prop for wizard form data
    type: Object,
    required: false,
  },
},
  setup(__props) {

const props = __props;


const currentYear = new Date().getFullYear();
const nextYear = currentYear + 1;

const username = computed(() => authStore.user.value?.name || '');

const currentYearTitle = computed(() => 
  t('fr.tax_results.current_year_title', `Totale ${currentYear}`, { currentYear })
);

const nextYearTitle = computed(() => 
  t('fr.tax_results.next_year_title', `Previsione ${nextYear}`, { nextYear })
);

// Helper function to calculate correct flat tax rate
const calculateFlatTaxRate = (yearData: any): number => {
  // If API already provides the correct rate, use it
  if (yearData?.aliquotaForfettaria) {
    return yearData.aliquotaForfettaria;
  }
  if (yearData?.aliquotaImpostaSostitutiva) {
    return yearData.aliquotaImpostaSostitutiva;
  }

  // Otherwise calculate based on form data
  if (props.formData?.isStartup && yearData?.yearsActive <= 5) {
    return 5; // 5% for startups within first 5 years
  }

  return 15; // 15% standard rate
};

const calculateChartAmounts = (data: any) => {
  if (!data) return {
    taxAmount: 0,
    inpsVariableAmount: 0,
    inpsFixedAmount: 0,
    contribSoggettivo: 0,
    contribIntegrativo: 0,
    contribMaternita: 0,
    contributionType: 'INPS'
  };

  // Verifica se è una cassa professionale
  const isProfessional = data.contributionBreakdown !== undefined;

  // Per il grafico sommiamo sempre: saldo + acconti dell'anno corrente
  // Questo mostra tutti i versamenti che l'utente deve fare nell'anno
  const taxAmountRaw = (
    (data.saldoImpostaSostitutiva || data.adjustedTaxBalance || 0) +
    (data.firstAccontoImpostaSostitutiva || 0) +
    (data.secondAccontoImpostaSostitutiva || 0)
  );
  const taxAmount = Number(taxAmountRaw.toFixed(2));

  if (isProfessional) {
    // Casse professionali: usa contributionBreakdown
    const breakdown = data.contributionBreakdown;
    return {
      taxAmount,
      inpsVariableAmount: 0,
      inpsFixedAmount: 0,
      contribSoggettivo: Number((breakdown?.soggettivo?.dovuto || 0).toFixed(2)),
      contribIntegrativo: Number((breakdown?.integrativo?.dovuto || 0).toFixed(2)),
      contribMaternita: Number((breakdown?.maternita?.importo || 0).toFixed(2)),
      contributionType: 'PROFESSIONAL'
    };
  } else {
    // INPS: logica esistente
    const inpsVariableAmountRaw = (
      (data.inpsSaldo || 0) +
      (data.firstAccontoINPS || 0) +
      (data.secondAccontoINPS || 0)
    );
    const inpsVariableAmount = Number(inpsVariableAmountRaw.toFixed(2));

    let inpsFixedAmountRaw = 0;
    if (props.contributionRegime === 'IVS_COMMERCIANTI') {
      inpsFixedAmountRaw = 4549.70;
    } else if (props.contributionRegime === 'IVS_ARTIGIANI') {
      inpsFixedAmountRaw = 4460.64;
    }
    const inpsFixedAmount = Number(inpsFixedAmountRaw.toFixed(2));

    return {
      taxAmount,
      inpsVariableAmount,
      inpsFixedAmount,
      contribSoggettivo: 0,
      contribIntegrativo: 0,
      contribMaternita: 0,
      contributionType: 'INPS'
    };
  }
};



const formatCurrency = (value: number) => {
  if (value === null || value === undefined || isNaN(value)) {
    return '€ 0,00';
  }

  const formatted = Math.abs(value).toFixed(2);
  const parts = formatted.split('.');
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const decimalPart = parts[1];

  const sign = value < 0 ? '-' : '';
  return sign + '€ ' + integerPart + ',' + decimalPart;
};



const getNextDeadlineCount = () => {
  const today = new Date();
  let count = 0;

  // Count current year deadlines
  if (props.results?.current?.deadlines) {
    count += props.results.current.deadlines.filter((deadline: any) => {
      return new Date(deadline.date) > today;
    }).length;
  }

  // Count next year deadlines
  if (props.results?.predictions?.deadlines) {
    count += props.results.predictions.deadlines.filter((deadline: any) => {
      return new Date(deadline.date) > today;
    }).length;
  }

  return count;
};

const getAvgMonthlyRate = () => {
  return props.liquidityResults?.metadata?.avgRate || null;
};

// Function to get current balance (saldo accumulato) from wizard form data
const getCurrentBalance = () => {
  // Get from wizard form data - this is the input from the user
  if (props.formData?.currentBalance !== undefined && props.formData?.currentBalance !== null) {
    return props.formData.currentBalance;
  }
  // Fallback to 0 if not found
  return 0;
};

// Simplified currency formatter without double € symbol
const formatCurrencySimple = (value: number) => {
  if (value === null || value === undefined || isNaN(value)) {
    return '€0,00';
  }

  return new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("h3", _hoisted_8, [
                    _createTextVNode(_toDisplayString(_unref(t)('fr.tax_results.title_part1', 'Risultati')) + " ", 1),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)('fr.tax_results.title_part2', 'Calcolo')), 1)
                  ]),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)('fr.tax_results.description', 'Ecco il piano personalizzato che abbiamo creato per te, {username}', { username: username.value })), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                        _createElementVNode("i", { class: "material-symbols-outlined" }, "savings")
                      ], -1)),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(t)('fr.tax_results.accumulated_balance', 'Saldo Accumulato')), 1),
                        _createElementVNode("strong", _hoisted_16, _toDisplayString(formatCurrencySimple(getCurrentBalance())), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "col-lg-4 col-md-4 col-sm-4" }, [
                _createElementVNode("div", { class: "welcome-img text-center text-sm-end mt-4 mt-sm-0" }, [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: "welcome"
                  })
                ])
              ], -1))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createVNode(TaxBreakdownChart, {
          title: currentYearTitle.value,
          chartTaxTotal: calculateChartAmounts(__props.results.current).taxAmount,
          chartInpsVariableTotal: calculateChartAmounts(__props.results.current).inpsVariableAmount,
          chartInpsFixedTotal: calculateChartAmounts(__props.results.current).inpsFixedAmount,
          chartContribSoggettivo: calculateChartAmounts(__props.results.current).contribSoggettivo,
          chartContribIntegrativo: calculateChartAmounts(__props.results.current).contribIntegrativo,
          chartContribMaternita: calculateChartAmounts(__props.results.current).contribMaternita,
          contributionType: calculateChartAmounts(__props.results.current).contributionType,
          fatturato: __props.results.current?.fatturatoPrecedente || 0,
          calculationDetails: __props.results.current?.calculationDetails || null,
          showSummary: true,
          year: _unref(currentYear) - 1,
          summaryData: {
            fatturato: __props.results.current?.fatturatoPrecedente || 0,
            aliquota: calculateFlatTaxRate(__props.results.current),
            redditoImponibile: __props.results.current?.grossTaxableIncome || 0,
            inpsSaldo: __props.results.current?.previousYearInpsSaldoPaid || 0,
            inpsAcconti: __props.results.current?.previousYearInpsAdvancesPaid || 0,
            irpefAcconti: __props.results.current?.previousYearTaxAdvancesPaid || 0,
            totaleImposte: __props.results.current?.totalDue || 0
          }
        }, null, 8, ["title", "chartTaxTotal", "chartInpsVariableTotal", "chartInpsFixedTotal", "chartContribSoggettivo", "chartContribIntegrativo", "chartContribMaternita", "contributionType", "fatturato", "calculationDetails", "year", "summaryData"])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(TaxBreakdownChart, {
          title: nextYearTitle.value,
          chartTaxTotal: calculateChartAmounts(__props.results.predictions).taxAmount,
          chartInpsVariableTotal: calculateChartAmounts(__props.results.predictions).inpsVariableAmount,
          chartInpsFixedTotal: calculateChartAmounts(__props.results.predictions).inpsFixedAmount,
          chartContribSoggettivo: calculateChartAmounts(__props.results.predictions).contribSoggettivo,
          chartContribIntegrativo: calculateChartAmounts(__props.results.predictions).contribIntegrativo,
          chartContribMaternita: calculateChartAmounts(__props.results.predictions).contribMaternita,
          contributionType: calculateChartAmounts(__props.results.predictions).contributionType,
          fatturato: __props.results.predictions?.fatturatoPrecedente || __props.results.current?.fatturatoPrecedente || 0,
          calculationDetails: __props.results.predictions?.calculationDetails || null,
          showSummary: true,
          year: _unref(currentYear),
          summaryData: {
            fatturato: __props.results.predictions?.fatturatoPrecedente || __props.results.current?.fatturatoPrecedente || 0,
            aliquota: calculateFlatTaxRate(__props.results.predictions),
            redditoImponibile: __props.results.predictions?.grossTaxableIncome || 0,
            inpsSaldo: __props.results.predictions?.previousYearInpsSaldoPaid || 0,
            inpsAcconti: __props.results.predictions?.previousYearInpsAdvancesPaid || 0,
            irpefAcconti: __props.results.predictions?.previousYearTaxAdvancesPaid || 0,
            totaleImposte: __props.results.predictions?.totalDue || 0
          }
        }, null, 8, ["title", "chartTaxTotal", "chartInpsVariableTotal", "chartInpsFixedTotal", "chartContribSoggettivo", "chartContribIntegrativo", "chartContribMaternita", "contributionType", "fatturato", "calculationDetails", "year", "summaryData"])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createVNode(DeadlinesWidget, { results: __props.results }, null, 8, ["results"])
      ])
    ]),
    (__props.liquidityResults)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createVNode(MonthlyFlowChart, { schedule: __props.liquidityResults }, null, 8, ["schedule"])
          ])
        ]))
      : _createCommentVNode("", true),
    (__props.liquidityResults)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createVNode(LiquidityStatsBoxes, { schedule: __props.liquidityResults }, null, 8, ["schedule"])
        ]))
      : _createCommentVNode("", true),
    (__props.liquidityResults)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createVNode(LiquidityScheduleTable, { schedule: __props.liquidityResults }, null, 8, ["schedule"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})